<template>
  <div class="create-brand" v-cloak>
    <div class="container">
      <div
        v-if="
          typeof getActiveUserData.user !== 'undefined' &&
            Object.keys(getActiveUserData.user).length
        "
      >
        <adminvue-projects-vue
          v-if="getActiveUserData.userRoles == 'admin'"
        ></adminvue-projects-vue>
        <salesteamleadvue-projects-vue
          v-else-if="
          (getActiveUserData.userRoles == 'salesteamlead') ||
          (getActiveUserData.userRoles == 'salesmanager') ||
          (getActiveUserData.userRoles == 'marketingperson') ||
          (getActiveUserData.userRoles == 'marketingmanager')"
        ></salesteamleadvue-projects-vue>
        <salespersonvue-projects-vue
          v-else-if="getActiveUserData.userRoles == 'salesperson'"
        ></salespersonvue-projects-vue>
        <not-found v-else></not-found>
      </div>
      <div v-else class="white-row loader-route">
        <div class="lds-sub-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import adminvue from "./create/admin-vue";
import salesteamleadvue from "./create/salesteamlead-vue";
import salespersonvue from "./create/salesperson-vue";
import noComponent from "../../components/noComponentFound";

export default {
  components: {
    "adminvue-projects-vue": adminvue,
    "salesteamleadvue-projects-vue": salesteamleadvue,
    "salespersonvue-projects-vue": salespersonvue,
    "not-found": noComponent
    // "clientvue-projects-vue": clientvue,
    // "default-projects-vue": defaultvue
  },
  computed: {
    getActiveUserData() {
      return this.$store.state.auth;
    }
  }
};
</script>
